import React, {useState} from "react";
import "./FeatureItem.css"; // include animation styles

export const FeatureItem = ({title, description, iconClass}) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
            <div
      className="feature-item card shadow-sm mb-3 border-0"
      onClick={() => setIsOpen(!isOpen)}
                style={{cursor: "pointer"}}
            >
      <div className="card-body d-flex align-items-center">
        <div className="me-3 text-primary">
          <i className={iconClass} style={{ fontSize: "1.8rem" }}></i>
                </div>

        <div className="flex-grow-1">
          <h5 className="mb-1">{title}</h5>
                    <div className={`collapse-text ${isOpen ? "open" : ""}`}>
            <small className="text-muted">{description}</small>
                    </div>
                </div>

        <div className="ms-3 text-end">
                    <i
            className={`bi ${isOpen ? "bi-chevron-up" : "bi-chevron-down"} transition-arrow`}
            style={{ fontSize: "1.2rem" }}
                    ></i>
                </div>

            </div>
        </div>
    );
};
